module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo-worklayer-blue.png";